import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import installElementPlus from './plugins/element'
import i18n from './plugins/i18n'
import * as ELIcons from '@element-plus/icons-vue'
import './assets/css/icon.css'
import './assets/css/text/text.css'
import './assets/css/fonts.css'
import { vScrollBottom } from './plugins/directives'
// import "element-plus/es/components/loading/style/index";

// createApp(App).use(store).use(router).mount('#app')
const app = createApp(App)

installElementPlus(app)

vScrollBottom(app)
// for (let iconName in ELIcons) {
// 	app.component(iconName, ELIcons[iconName])
// }	

for (const [key, component] of Object.entries(ELIcons)) {
    app.component(key, component)
}

app
    .use(store)
    .use(router)
    .use(i18n)
    .mount('#app')
